<template>
  <div class="seccion-invitacion">
    <div class="contenido-invitacion">

      <p class="bendicion" ref="bendicionRef">
        Con la bendición de Dios y de mis Padres
      </p>

      <div class="nombres-padres" ref="nombresRef">
        <p>NOE & MARILU TOBOADA</p>
        <p></p>
        <p></p>
      </div>

      <div class="imagen-wrapper" ref="imagenRef">
        <img src="@/assets/porta.jpeg" alt="Quinceañera" class="imagen-ovalada" />
      </div>

      <p class="mensaje-invitacion" ref="mensajeRef">
        Tenemos el honor de invitarlos a celebrar los<br />
        XV años de nuestra hija
      </p>

      <br><br>

      <!-- Padrinos -->
      <span class="bendicion1" ref="padrinosTituloRef">Padrinos de Bautizo:</span>
      <div class="subrayado" aria-hidden="true" ref="padrinosUnderlineRef"></div>

      <br>

      <span class="nombres-padres1" ref="padrinosNombresRef">Rafael y Eva Salinas</span>

    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'InvitacionXV',
  setup() {
    const bendicionRef = ref(null);
    const nombresRef = ref(null);
    const imagenRef = ref(null);
    const mensajeRef = ref(null);

    // Nuevos refs para Padrinos
    const padrinosTituloRef = ref(null);
    const padrinosUnderlineRef = ref(null);
    const padrinosNombresRef = ref(null);

    const animateOnScroll = (element, animationFn) => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          animationFn();
          observer.unobserve(entry.target); // solo 1 vez
        }
      }, { threshold: 0.3 });
      observer.observe(element);
    };

    onMounted(() => {
      if (bendicionRef.value) {
        animateOnScroll(bendicionRef.value, () =>
          gsap.fromTo(
            bendicionRef.value,
            { opacity: 0, y: -20 },
            { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }
          )
        );
      }

      if (nombresRef.value) {
        animateOnScroll(nombresRef.value, () =>
          gsap.fromTo(
            nombresRef.value,
            { opacity: 0, scale: 0.8 },
            { opacity: 1, scale: 1, duration: 1.2, ease: 'back.out(1.7)' }
          )
        );
      }

      if (imagenRef.value) {
        animateOnScroll(imagenRef.value, () =>
          gsap.fromTo(
            imagenRef.value,
            { opacity: 0, scale: 0.3 },
            { opacity: 1, scale: 1, duration: 1.5, ease: 'elastic.out(1, 0.5)' }
          )
        );
      }

      if (mensajeRef.value) {
        animateOnScroll(mensajeRef.value, () =>
          gsap.fromTo(
            mensajeRef.value,
            { opacity: 0, y: 40 },
            { opacity: 1, y: 0, duration: 1.3, ease: 'power3.out', delay: 0.2 }
          )
        );
      }

      // ------- Animaciones de PADRINOS -------
      if (padrinosTituloRef.value) {
        animateOnScroll(padrinosTituloRef.value, () => {
          // Título “Padrinos de Bautizo:”
          gsap.fromTo(
            padrinosTituloRef.value,
            { opacity: 0, y: 18, letterSpacing: '1px' },
            { opacity: 1, y: 0, letterSpacing: '0.5px', duration: 0.7, ease: 'power2.out' }
          );

          // Subrayado que se “dibuja”
          if (padrinosUnderlineRef.value) {
            gsap.fromTo(
              padrinosUnderlineRef.value,
              { scaleX: 0, opacity: 0 },
              { scaleX: 1, opacity: 1, transformOrigin: 'left center', duration: 0.6, ease: 'power3.out', delay: 0.15 }
            );
          }
        });
      }

      if (padrinosNombresRef.value) {
        animateOnScroll(padrinosNombresRef.value, () =>
          // Nombres entran con leve “slide up”
          gsap.fromTo(
            padrinosNombresRef.value,
            { opacity: 0, y: 16 },
            { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', delay: 0.05 }
          )
        );
      }
    });

    return {
      bendicionRef,
      nombresRef,
      imagenRef,
      mensajeRef,
      padrinosTituloRef,
      padrinosUnderlineRef,
      padrinosNombresRef
    };
  }
};
</script>

<style scoped>
.seccion-invitacion {
  background: #fefefe;
  padding: 60px 0px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  margin-bottom: -60px;
}

.contenido-invitacion {
  max-width: 500px;
  margin: 0 auto;
}

/* Bendición */
.bendicion {
  font-family: 'titulos', cursive;
  font-size: 36px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  color: #333232;
  opacity: 0; /* evita parpadeo antes de animar */
}

/* Nombres de padres */
.nombres-padres {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  color: #2b2b2b;
  margin-bottom: 30px;
  opacity: 0; /* evita parpadeo antes de animar */
}

/* Imagen */
.imagen-wrapper {
  width: 300px;
  height: 360px;
  margin: 0 auto 30px;
  overflow: hidden;
  background: white;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  opacity: 0; /* evita parpadeo antes de animar */
}

.imagen-ovalada {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Mensaje principal */
.mensaje-invitacion {
  font-size: 28px !important;
  line-height: 1.7;
  color: #1e1d1d;
  font-family: 'titulos', sans-serif;
  letter-spacing: 1px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  opacity: 0; /* evita parpadeo antes de animar */
}

/* ----- Padrinos ----- */
.bendicion1 {
  display: inline-block;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  font-size: 20px;
  color: #2b2b2b;
  opacity: 0; /* evita parpadeo antes de animar */
}

.subrayado {
  width: 180px;
  height: 2px;
  margin: 6px auto 4px;
  background: linear-gradient(90deg, rgba(0,0,0,0), #b89cc8, rgba(0,0,0,0));
  transform: scaleX(0);
  opacity: 0;
}

.nombres-padres1 {
  display: inline-block;
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.3px;
  opacity: 0; /* evita parpadeo antes de animar */
}

/* Responsive */
@media (max-width: 420px) {
  .imagen-wrapper { width: 260px; height: 320px; }
  .bendicion { font-size: 32px; }
  .mensaje-invitacion { font-size: 24px !important; }
  .subrayado { width: 160px; }
}
</style>
